'use client';

import { useMemo } from 'react';
import type { CallbackSettingsInput } from '@jlg-website/shared';
import { resolveVisitorTimeZone } from './visitor-time-zone';

/**
 * Zone the visitor reads their times in, looked up from the ZIP code they gave. A ZIP the lookup
 * does not know leaves the office zone as the honest default.
 *
 * The single place both flows derive it, so a call booked from either carries the same `tz`.
 */
export function useVisitorTimeZone(zipCode: string, settings: CallbackSettingsInput) {
  return useMemo(() => resolveVisitorTimeZone(zipCode) ?? settings.tz, [zipCode, settings.tz]);
}
